export class LeaveType 
{
    public LeaveTypeId : Number;
    public LeaveTypeName : string;
    public LeaveTypeCode : string;
    public IsActive : boolean;
}